import { PAGINATION } from 'config/constants';

export default class PaginationOptions {
	page;
	size;

	constructor(page = 1, size = PAGINATION.defaultSize) {
		this.page = page;
		this.size = size;
	}
}



// WEBPACK FOOTER //
// ./src/utils/domain/PaginationOptions.js